{
  "version": 1,
  "asset_id": "e7075424-330a-4a4d-96ac-6ee72ea72f06",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/e7075424-330a-4a4d-96ac-6ee72ea72f06/wordmark-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/e7075424-330a-4a4d-96ac-6ee72ea72f06/wordmark-1200.avif",
  "original_filename": "wordmark-1200.avif",
  "size": 21312,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:18:48Z"
}
